import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/close_btn.png'
import _imports_1 from '../../assets/icon/trash_icon.svg'


const _hoisted_1 = { class: "popup" }
const _hoisted_2 = { class: "file-upload-popup" }
const _hoisted_3 = { class: "popup-header" }
const _hoisted_4 = { class: "popup_title" }
const _hoisted_5 = {
  key: 0,
  class: "popup-body"
}
const _hoisted_6 = { class: "contact_body" }
const _hoisted_7 = { class: "pay_content_box" }
const _hoisted_8 = ["onUpdate:modelValue", "readonly"]
const _hoisted_9 = { class: "pay_content_box" }
const _hoisted_10 = ["onUpdate:modelValue", "readonly"]
const _hoisted_11 = { class: "pay_content_box" }
const _hoisted_12 = ["onUpdate:modelValue", "readonly"]
const _hoisted_13 = { class: "pay_content_box" }
const _hoisted_14 = ["onUpdate:modelValue", "readonly"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "popup-footer" }

import { ref, onMounted } from "vue";
import { Announce } from "../../common/types";
import announceAPI from "../../api/announceAPI";

// Props 정의
interface PaymentInfo {
  지급순번: number | null;
  지급일자: string;
  지급구분: string;
  지급율: number;
  지급금액: number;
  발주처수주구분: string | null;
  수행회원금액확인?: boolean;
  수행회원입금확인?: boolean;
}
// 원본 데이터와 변경된 데이터 관리

export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentInfoPop',
  props: {
    announceData: {},
    발주처수주구분: {}
  },
  emits: ["closePaymentInfoPopup", "getDetail"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// 타입 정의
const originalData = ref<PaymentInfo[]>([]); // 원본 데이터
const paymentList = ref<PaymentInfo[]>([]); // 사용자 입력 데이터

// 초기화
onMounted(() => {
  console.log(props.announceData.공고대금지급정보)
  // 원본 데이터 가져오기
  originalData.value = props.announceData.공고대금지급정보
    .filter((item) => item.발주처수주구분 === props.발주처수주구분)
    .map((item) => ({
      지급순번: item.지급순번 ?? null,
      지급구분: item.지급구분 || "",
      지급일자: item.지급일자 || "",
      지급율: item.지급율 || 0,
      지급금액: item.지급금액 || 0,
      발주처수주구분: item.발주처수주구분 || null,
      수행회원금액확인: item.수행회원금액확인 || false,
      수행회원입금확인: item.수행회원입금확인 || false,
    }));

  // 초기 paymentList 설정
  paymentList.value = JSON.parse(JSON.stringify(originalData.value));

  // 원본 데이터가 없으면 기본값 추가
  if (paymentList.value.length === 0) {
    addPayment();
  }
});

// 리스트 추가
const addPayment = () => {
  paymentList.value.push({
    지급순번: null,
    지급구분: "",
    지급일자: "",
    지급율: 0,
    지급금액: 0,
    발주처수주구분: props.발주처수주구분,
  });
};

// 리스트 삭제
const removePayment = (index: number) => {
  paymentList.value.splice(index, 1);
};

// 저장 로직
const save = async () => {
  const isConfirmed = confirm("저장 하시겠습니까?");
  if (!isConfirmed) return;

  // 삭제된 데이터
  const deletedData = originalData.value.filter((original) => !paymentList.value.some((current) => current.지급순번 === original.지급순번)).map((item) => item.지급순번);

  // 추가된 데이터
  const addedData = paymentList.value.filter((current) => !current.지급순번);

  // 수정된 데이터
  const updatedData = paymentList.value.filter((current) => 
    originalData.value.some((original) => original.지급순번 === current.지급순번 && 
    (original.지급구분 !== current.지급구분 || original.지급일자 !== current.지급일자 || original.지급율 !== current.지급율 || original.지급금액 !== current.지급금액))
  );

  try {
    // API 호출
    await announceAPI.savePayment(props.announceData.공고순번, {
      공고대금지급정보등록: addedData,
      공고대금지급정보수정: updatedData,
      공고대금지급정보삭제: deletedData,
    });

    alert("변경 사항이 저장되었습니다.");
    emit("closePaymentInfoPopup"); // 팝업 닫기
    emit("getDetail");
  } catch (error) {
    console.error("저장 중 오류 발생:", error);
    alert("저장 중 오류가 발생했습니다.");
  }
};

const emit = __emit;
const closePopup = () => {
  emit("closePaymentInfoPopup");
  emit("getDetail");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "popup_cover" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(props.발주처수주구분 == '발주처' ? props.발주처수주구분 : '수주/수행') + " 대금지급정보 등록", 1),
        _createElementVNode("img", {
          src: _imports_0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (closePopup())),
          class: "close_icon"
        })
      ]),
      (props.발주처수주구분 == '발주처' || props.발주처수주구분 == '수주')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"contact_header\" data-v-6dc5a370><div class=\"contact_header_column\" data-v-6dc5a370>지급구분</div><div class=\"contact_header_column\" data-v-6dc5a370>지급일자</div><div class=\"contact_header_column\" data-v-6dc5a370>지급율</div><div class=\"contact_header_column\" data-v-6dc5a370>지급금액</div></div>", 1)),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "contact_div",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                      class: "contact_inp",
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((item.지급구분) = $event),
                      readonly: item.수행회원금액확인 || item.수행회원입금확인
                    }, null, 8, _hoisted_8), [
                      [_vModelText, item.지급구분]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      class: "contact_inp",
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((item.지급일자) = $event),
                      readonly: item.수행회원금액확인 || item.수행회원입금확인
                    }, null, 8, _hoisted_10), [
                      [_vModelText, item.지급일자]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      class: "contact_inp pay_rate",
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((item.지급율) = $event),
                      readonly: item.수행회원금액확인 || item.수행회원입금확인
                    }, null, 8, _hoisted_12), [
                      [_vModelText, item.지급율]
                    ]),
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "pay_unit" }, "%", -1))
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      class: "contact_inp pay_price",
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((item.지급금액) = $event),
                      readonly: item.수행회원금액확인 || item.수행회원입금확인
                    }, null, 8, _hoisted_14), [
                      [_vModelText, item.지급금액]
                    ]),
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "pay_unit" }, "원", -1))
                  ]),
                  (!(item.수행회원금액확인 || item.수행회원입금확인))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "delete_icon_box",
                        onClick: ($event: any) => (removePayment(index))
                      }, _cache[5] || (_cache[5] = [
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: "삭제 아이콘"
                        }, null, -1)
                      ]), 8, _hoisted_15))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createElementVNode("div", {
                class: "add_body_wrap",
                onClick: addPayment
              }, "리스트 추가+")
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", {
          class: "popup_close_btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (closePopup()))
        }, "취소"),
        _createElementVNode("div", {
          class: "popup_confirm_btn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (save()))
        }, "저장")
      ])
    ])
  ]))
}
}

})